"use client";

import Link from "next/link";
import type { PostCategoryT } from "@/app/types/posts";

interface PostCategoryBadgeProps {
  category: PostCategoryT;
  clickable?: boolean;
}

export default function PostCategoryBadge({
  category,
  clickable = true,
}: PostCategoryBadgeProps) {
  const badgeClassName =
    "bg-secondary hover:bg-secondary/80 inline-block rounded-full px-3 py-1 text-xs transition-colors";

  if (!clickable) {
    return <span className={badgeClassName}>{category.label}</span>;
  }

  return (
    <Link
      href={`/kategorien/${category.slug}`}
      className={badgeClassName}
      onClick={(e) => e.stopPropagation()}
    >
      {category.label}
    </Link>
  );
}
